import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";

export function formatar_numeros_Cabecalho_11(item: any) {
    return {
        ...item,
        fossas: formatarNumero_recebido_com_casa_decimais(item.fossas),
        nitreiras: formatarNumero_recebido_com_casa_decimais(item.nitreiras),
        valas_condu_fluentes: formatarNumero_recebido_com_casa_decimais(item.valas_condu_fluentes),
        lagos_imperm: formatarNumero_recebido_com_casa_decimais(item.lagos_imperm),
        outros_reservatorios: formatarNumero_recebido_com_casa_decimais(item.outros_reservatorios),
        contratualizada: formatarNumero_recebido_com_casa_decimais(item.contratualizada),
    };
}

export function formatar_numeros_tabela_dois_11(item: any) {
    return {
        ...item,
        n_animais: formatarNumero_recebido_com_casa_decimais(item.n_animais),
        ex_chorume: formatarNumero_recebido_com_casa_decimais(item.ex_chorume),
        ex_estrume: formatarNumero_recebido_com_casa_decimais(item.ex_estrume),
        exter_chorume: formatarNumero_recebido_com_casa_decimais(item.exter_chorume),
        exter_estrume: formatarNumero_recebido_com_casa_decimais(item.exter_estrume),
        vendido_chorume: formatarNumero_recebido_com_casa_decimais(item.vendido_chorume),
        vendido_estrume: formatarNumero_recebido_com_casa_decimais(item.vendido_estrume),
        quant_chorume: formatarNumero_recebido_com_casa_decimais(item.quant_chorume),
        quant_estrume: formatarNumero_recebido_com_casa_decimais(item.quant_estrume),
    };
}

export function formatar_numeros_tabela_tres_11(item: any) {
    return {
        ...item,
        propria: formatarNumero_recebido_com_casa_decimais(item.propria),
        contratualizada: formatarNumero_recebido_com_casa_decimais(item.contratualizada),
        quant: formatarNumero_recebido_com_casa_decimais(item.quant),
    };
}